import { parse } from 'date-fns';
import {
  TimelineByProjects,
  TimelineByTeam,
  TimelineByTeam__Hours,
} from './types';

export const transformTimelineData = (data: TimelineByTeam[]) => {
  return (data ?? [])?.map((apiData, index) => {
    const { user, projects, timeline_segments } = apiData || {};
    const { id } = user || {};

    const transformedElements = (timeline_segments ?? [])?.map(
      (segment, index) => {
        const { start_date, end_date, projects, total_projects } =
          segment ?? {};

        return {
          id: `${start_date}-${end_date}-segment-${index}`,
          start: parse(start_date ?? '', 'MM-dd-yyyy', new Date()),
          end: parse(end_date ?? '', 'MM-dd-yyyy', new Date()),
          title:
            (projects ?? [])?.length === 1
              ? (projects ?? [])?.[0] ?? '0'
              : total_projects ?? '0',
        };
      }
    );
    const transformedProjects = (projects ?? [])?.map((project, index) => {
      const { start_date, end_date, capacity, name, bg_color } = project;

      return {
        id: `${start_date}-${end_date}-subTrack-${index}`,
        title: name ?? '',
        bg_color,
        elements: [
          {
            id: `${start_date}-${end_date}-subTrack-${index}`,
            start: parse(start_date ?? '', 'MM-dd-yyyy', new Date()),
            end: parse(end_date ?? '', 'MM-dd-yyyy', new Date()),
            title: `${capacity ?? '0'}% ${capacity ? 'Capacity' : '0'} `,
            bg_color,
          },
        ],
      };
    });

    return {
      id,
      isOpen: false,
      elements: transformedElements,
      tracks: transformedProjects,
      user,
    };
  });
};
export const transformTimelineDataByHours = (data: TimelineByTeam__Hours[]) => {
  return (data ?? [])?.map((apiData, index) => {
    const { user, projects, timeline_segments } = apiData || {};
    const { id } = user || {};

    const transformedElements = (timeline_segments ?? [])?.map(
      (segment, index) => {
        const { start_date, end_date, projects, total_hours } = segment ?? {};

        return {
          id: `${start_date}-${end_date}-segment-${index}`,
          start: parse(start_date ?? '', 'MM-dd-yyyy', new Date()),
          end: parse(end_date ?? '', 'MM-dd-yyyy', new Date()),
          title: `${total_hours ?? '0'}H`,
        };
      }
    );
    const transformedProjects = (projects ?? [])?.map((project, index) => {
      const { start_date, end_date, hours, name, bg_color } = project;

      const hoursElements = (hours ?? [])?.map((hour) => {
        const { start_date, end_date, hours } = hour ?? {};

        return {
          id: `${start_date}-${end_date}-subTrack-${index}`,
          start: parse(start_date ?? '', 'MM-dd-yyyy', new Date()),
          end: parse(end_date ?? '', 'MM-dd-yyyy', new Date()),
          title: `${hours ?? '0'}H`,
          bg_color,
        };
      });
      return {
        id: `${start_date}-${end_date}-subTrack-${index}`,
        title: name ?? '',
        bg_color,
        elements: hoursElements,
      };
    });

    return {
      id,
      isOpen: false,
      elements: transformedElements,
      tracks: transformedProjects,
      user,
    };
  });
};
export const transformTimelineDataByProjects = (data: TimelineByProjects[]) => {
  return (data ?? [])?.map((apiData, index) => {
    const { users, project, total_users } = apiData || {};
    const { id, start_date, end_date, bg_color } = project || {};

    const transformedProjects = (users ?? [])?.map((user, index) => {
      const { start_date, end_date, capacity, name, avatar } = user;

      return {
        id: `${start_date}-${end_date}-subTrack-${index}`,
        title: name ?? '',
        avatar,
        isProjectUser: true,
        elements: [
          {
            id: `${start_date}-${end_date}-subTrack-${index}`,
            start: parse(start_date ?? '', 'MM-dd-yyyy', new Date()),
            end: parse(end_date ?? '', 'MM-dd-yyyy', new Date()),
            title: `${capacity ?? '0'}% ${capacity ? 'Capacity' : '0'} `,
          },
        ],
      };
    });

    return {
      id,
      isOpen: false,
      bg_color,
      elements: [
        {
          id: `${start_date}-${end_date}-segment-${index}`,
          start: parse(start_date ?? '', 'MM-dd-yyyy', new Date()),
          end: parse(end_date ?? '', 'MM-dd-yyyy', new Date()),
          title: `${total_users ?? '0'} Members` ?? '0',
          isProject: true,
          bg_color,
        },
      ],
      tracks: transformedProjects,
      user: { ...project, bg_color, isProject: true },
    };
  });
};
